import React from 'react';
import { Link } from 'react-router';
import { appContext } from '../../util/decorators';

@appContext
export default class NoMatch extends React.PureComponent {
  render() {
    const t = this.context.app.t;

    return (
      <div className="no-match">
        <h1 className="heading">{t('NoMatch.heading')}</h1>
        <p>{t('NoMatch.body')}</p>
        <p><Link to="/">{t('NoMatch.viasport_startpage')}</Link></p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/404/NoMatch.jsx